export const style = {
  selectorWrapperColumn: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 20px 20px 0',
  },
  selectorWrapperRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0 20px 20px 0',
  },
  selector: {
    width: '200px',
    height: '36px',
  },
  label: {
    fontSize: '18px',
    paddingRight: '10px',
    fontWeight: 'bold',
  },
}
